const ClaimFlowStyles = {
  container: {
    maxWidth: 1200,
    mx: 'auto',
    p: 3,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    mb: 3,
  },
  backButton: {
    mr: 2,
  },
  title: {
    fontFamily: 'var(--font-noto-sans)',
  },
  stepLabel: {
    fontFamily: 'var(--font-noto-sans)',
  },
  paper: {
    mt: 4,
    p: 3,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    mt: 3,
  },
  button: {
    fontFamily: 'var(--font-noto-sans)',
  },
  alert: {
    fontFamily: 'var(--font-noto-sans)',
  },
};

export default ClaimFlowStyles;
